// client/src/components/SidebarLayout.js
import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaUserPlus,
  FaChartBar,
  FaUserCheck,
  FaSignOutAlt,
  FaChevronDown,
  FaBars,
  FaTimes,
  FaCalendar,
  FaList,
  FaClipboardList,
  FaUserClock,
} from "react-icons/fa";
import "./SidebarLayout.css";

const SidebarLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [adminName, setAdminName] = useState("Admin");
  const [role, setRole] = useState(
    localStorage.getItem("adminRole") || "admin",
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const name = localStorage.getItem("adminFirstName");
    if (name) setAdminName(name);
    const r = localStorage.getItem("adminRole");
    if (r) setRole(r);
  }, []);

  useEffect(() => {
    const onDocClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const isActive = (path) => {
    return location.pathname === path;
  };

  /* --------------------------- NAV ITEMS --------------------------- */

  const BASE_ITEMS = [{ label: "Dashboard", path: "/", icon: <FaHome /> }];

  const CHECKIN_ITEMS = [
    { label: "Check-In", path: "/check-in-name", icon: <FaUserCheck /> },
    { label: "Check-In List", path: "/checkin-list", icon: <FaList /> },

    // ✅ NEW — Kiosk Mode
    { label: "Kiosk Mode", path: "/kiosk-mode", icon: <FaUserClock /> },
  ];

  const ADMIN_ITEMS = [
    { label: "Reports", path: "/reports-master", icon: <FaChartBar /> },
    { label: "Masterlist", path: "/masterlist", icon: <FaClipboardList /> },
    { label: "Eventlist", path: "/eventlist", icon: <FaCalendar /> },
    { label: "Add User", path: "/add-user", icon: <FaUserPlus /> },
    { label: "Import Data", path: "/import-data", icon: <FaUserPlus /> },
    { label: "Ministries", path: "/ministries", icon: <FaList /> },
  ];

  // role-based navigation
  let navItems = [...BASE_ITEMS, ...CHECKIN_ITEMS];

  if (role === "admin" || role === "super_admin") {
    navItems = [...BASE_ITEMS, ...CHECKIN_ITEMS, ...ADMIN_ITEMS];
  }

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("adminFirstName");
    localStorage.removeItem("adminRole");
    navigate("/login");
  };

  return (
    <div
      className={`layout-container ${
        sidebarOpen ? "sidebar-visible" : "sidebar-hidden"
      }`}
    >
      <aside className={`sidebar ${sidebarOpen ? "open" : "collapsed"}`}>
        <button
          className="toggle-close-btn"
          onClick={() => setSidebarOpen(false)}
          aria-label="Close sidebar"
        >
          <FaTimes /> <span>Close</span>
        </button>

        <div className="sidebar-logo-container">
          <img
            src={`${process.env.PUBLIC_URL}/mtgilead.png`}
            alt="Mt. Gilead Logo"
            className="logo"
          />
          <div className="role-chip" title={`Signed in as: ${role}`}>
            <span>Hello, </span>
            {role.replace("_", " ")}
          </div>
        </div>

        <nav>
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${isActive(item.path) ? "active" : ""}`}
            >
              <span className="icon">{item.icon}</span>
              <span className="label">{item.label}</span>
            </Link>
          ))}
        </nav>
      </aside>

      <main className="main-content">
        <div className="topbar">
          {!sidebarOpen && (
            <button
              className="toggle-sidebar-btn"
              onClick={() => setSidebarOpen(true)}
              aria-label="Open sidebar"
            >
              <FaBars /> <span>Menu</span>
            </button>
          )}

          <div
            className="admin-dropdown"
            ref={dropdownRef}
            onClick={() => setDropdownOpen((s) => !s)}
          >
            <div className="avatar" aria-hidden="true">
              {adminName?.charAt(0)?.toUpperCase() || "A"}
            </div>
            <span className="admin-name">{adminName}</span>
            <FaChevronDown className="chevron" />

            {dropdownOpen && (
              <div className="dropdown-menu">
                <div className="dropdown-meta">
                  <div className="dropdown-name">{adminName}</div>
                  <div className="dropdown-role">
                    Role: {role.replace("_", " ")}
                  </div>
                </div>
                <button onClick={handleLogout}>
                  <FaSignOutAlt /> Logout
                </button>
              </div>
            )}
          </div>
        </div>

        {children}
      </main>
    </div>
  );
};

export default SidebarLayout;
